import { UnleashClient } from 'unleash-proxy-client'

// Initialize the Unleash client
let unleashClient

// unleashClient.updateContext({ userId: '123' }) // Optional: Update context if needed

export function isFeatureEnabled(featureName) {
  return unleashClient.isEnabled(featureName)
}

export function updateContext(context) {
  return unleashClient.updateContext(context)
}

export function getVariant(featureName) {
  return unleashClient.getVariant(featureName)
}

export function initialize(config) {
  unleashClient = new UnleashClient(config)
  unleashClient.start()
  return unleashClient
}

// export default unleashClient
